import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthWebService } from './authweb.service';

@Injectable()
export class SessionService {
  protected url: string = environment.authWebApi.url;
  protected icbmsUrl: string = environment.iCBMSWebApi.url;
  constructor(private http: HttpClient,public authWebService: AuthWebService) { }


  releaseScanner(pc_ip_address: string)
  {
    return this.http.get(this.icbmsUrl +'scanner/release/' + pc_ip_address);
  }

}